import { useEffect, useContext, useRef } from 'react';
import { FocusTrapContext } from './FocusTrapContext';
export function useFocusTrapChild(ref) {
    const context = useContext(FocusTrapContext);
    const prevRef = useRef(null);
    useEffect(() => {
        if (ref.current !== prevRef.current) {
            if (prevRef.current != null) {
                context.unregister(prevRef.current);
            }
            if (ref.current != null) {
                context.register(ref.current);
            }
            prevRef.current = ref.current;
        }
    });
    useEffect(() => {
        return () => {
            if (prevRef.current != null) {
                context.unregister(prevRef.current);
            }
        };
    }, []);
}
//# sourceMappingURL=useFocusTrapChild.js.map